import { authHeaders, handleAuthExpired } from "./auth";

/** Authed GET → JSON, throwing on a non-2xx status. The shared read helper for
 *  the console/admin API clients (POST/PATCH stay in their own modules). A 401
 *  drops the stale token and surfaces login so background reloads stop. */
export async function getJson<T>(url: string): Promise<T> {
  const res = await fetch(url, { headers: authHeaders() });
  if (res.status === 401) handleAuthExpired();
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as T;
}
